export default class SearchLocationAutocompleteItem {
  constructor({ shortName, longName, placeType, coordinates, bbox, id } = {}) {
    this.shortName = shortName || "";
    this.longName = longName || "";
    this.placeType = placeType || "";
    this.coordinates = coordinates || [];
    this.bbox = bbox || [];
    this.id = id || "";
  }
}
